import Session from '../entity/session';

const SET = 'currentSession#set';
const DISPOSE = 'currentSession#dispose';

export type State = Session | null;

type Action = {
  type: typeof SET | typeof DISPOSE;
  payload?: Session | null;
};

export const initialState = null;

const currentSession = (previousState: State = initialState, { type, payload }: Action): State => {
  if (type === SET) {
    return payload as Session;
  }

  if (type === DISPOSE) {
    return null;
  }

  return previousState;
};

export const set = (session: Session): Action => ({
  type: SET,
  payload: session,
});

export const dispose = (): Action => ({
  type: DISPOSE,
});

export default currentSession;
